
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 65"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('circle',{attrs:{"fill":"#D8D8D8","opacity":".347","cx":"32","cy":"32.663","r":"32"}}),_c('path',{attrs:{"d":"M40.5 40c1.375 0 2.5-1.125 2.5-2.5v-17c0-1.375-1.125-2.5-2.5-2.5h-23a2.507 2.507 0 00-2.5 2.5v17c0 1.375 1.125 2.5 2.5 2.5h23zm0-2h-23c-.266 0-.5-.268-.5-.571V22.57c0-.303.234-.571.5-.571h23c.266 0 .5.268.5.571v14.86c0 .303-.234.571-.5.571zm-20-11c.266 0 .5-.234.5-.5v-1c0-.266-.234-.5-.5-.5h-1c-.266 0-.5.234-.5.5v1c0 .266.234.5.5.5h1zm18 0c.266 0 .5-.234.5-.5v-1c0-.266-.234-.5-.5-.5h-15c-.266 0-.5.234-.5.5v1c0 .266.234.5.5.5h15zm-18 8c.266 0 .5-.234.5-.5v-1c0-.266-.234-.5-.5-.5h-1c-.266 0-.5.234-.5.5v1c0 .266.234.5.5.5h1zm18 0c.266 0 .5-.234.5-.5v-1c0-.266-.234-.5-.5-.5h-15c-.266 0-.5.234-.5.5v1c0 .266.234.5.5.5h15z","fill":"#000","fill-rule":"nonzero"}}),_c('path',{attrs:{"d":"M20.5 31c.266 0 .5-.234.5-.5v-1c0-.266-.234-.5-.5-.5h-1c-.266 0-.5.234-.5.5v1c0 .266.234.5.5.5h1zm18 0c.266 0 .5-.234.5-.5v-1c0-.266-.234-.5-.5-.5h-15c-.266 0-.5.234-.5.5v1c0 .266.234.5.5.5h15z","fill":"#2CC692"}}),_c('g',{attrs:{"fill-rule":"nonzero"}},[_c('path',{attrs:{"d":"M33 28.503l17.98 11.236-6.864 1.087 5.588 7.874-3.356 1.828-5.94-8.37-4.436 5.111L33 28.503z","fill":"#F2F2F2"}}),_c('path',{attrs:{"d":"M34.816 31.194l13.63 10.078-5.239.83 4.472 7.215-2.466 1.527-4.691-7.57-3.124 4.224-2.582-16.304z","fill":"#000","opacity":".918"}})])])])
          )
        }
      }
    